export const crewDataNA = 'N/A';
export const RRO_OPERATOR_LABEL = 'RRO';
export const EB_OPERATOR_LABEL = 'EB';
export const DOMICILE_LABEL = 'Domicile';
